

  <mat-vertical-stepper [linear]="isLinear" #stepper>
    <mat-step [stepControl]="firstFormGroup">
      <form [formGroup]="firstFormGroup">
        <ng-template matStepLabel>Completa tu informacion personal</ng-template>      
        <mat-form-field >
          <mat-label >DNI</mat-label>
          <input matInput formControlName="firstCtrl" required>
        </mat-form-field>      
        <mat-form-field > 
          <mat-label >E-Mail</mat-label>
          <input matInput  formControlName="firstCtrl"  required>
        </mat-form-field>  
        <mat-form-field>
          <mat-label >Celular</mat-label>
          <input matInput  formControlName="firstCtrl" required>
        </mat-form-field>      
        
        <div *ngIf="habilitaNombre">
            <mat-form-field>         
              <mat-label >Nombre</mat-label>
              <input matInput formControlName="firstCtrl">         
            </mat-form-field>  
        </div>

        <div *ngIf="habilitaApellido">
          <mat-form-field>         
            <mat-label >Apellido</mat-label>
            <input matInput formControlName="firstCtrl"   required>         
          </mat-form-field> 
        </div>     
     
        <div *ngIf="habilitaLocalidad">
          <mat-form-field >
            <mat-label>Localidad</mat-label>
            <mat-select formControlName="firstCtrl">
              <mat-option value="option">CABA</mat-option>
            </mat-select>
          </mat-form-field>
      </div>

      <div *ngIf="habilitaProvincia">
        <mat-form-field >
          <mat-label>Provincia</mat-label>
          <mat-select formControlName="firstCtrl">
            <mat-option value="option">BS AS</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12">
        <span class="type--fine-print">By signing up, you agree to the
            <a href="#">Terms of Service</a>
        </span>
     </div>
     <div>
          <button mat-button matStepperNext>Next</button>
      </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="secondFormGroup">
      <form [formGroup]="secondFormGroup">
        <ng-template matStepLabel>Confirmanos tu identidad identidad</ng-template>       
        <mat-form-field>
          <mat-label>Ingrese codigo SMS</mat-label>
          <input matInput formControlName="secondCtrl" placeholder="Ingrese codigo SMS"
                 required>
        </mat-form-field>     

      

        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>Fin</ng-template>
      <p>Gracias por haber participado!!.</p>
      <div>      
        <button mat-button (click)="stepper.reset()">Cargar otro</button>
      </div>
    </mat-step>
  </mat-vertical-stepper>
  
  
  <!-- Copyright 2020 Google LLC. All Rights Reserved.
      Use of this source code is governed by an MIT-style license that
      can be found in the LICENSE file at http://angular.io/license -->